import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "电影", path: "/category/movie" },
  { name: "电视剧", path: "/category/tv" },
  { name: "综艺", path: "/category/variety" },
  { name: "动漫", path: "/category/anime" },
  { name: "资讯", path: "/article/2024-chinese-film-box-office-top10" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading font-bold text-lg whitespace-nowrap ${
                scrolled ? "text-foreground-900" : "text-white"
              }`}
            >
              91麻豆免费视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : scrolled
                      ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-900"
                      : "text-white/90 hover:text-white hover:bg-white/10"
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-10 h-10 rounded-lg flex items-center justify-center cursor-pointer transition-colors duration-200 hover:bg-background-100">
              <i
                className={`ri-search-line text-lg ${
                  scrolled ? "text-foreground-700" : "text-white"
                }`}
              ></i>
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap bg-accent-500 text-background-50 hover:bg-accent-600`}
            >
              联系我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`ri-${
                mobileOpen ? "close" : "menu"
              }-line text-2xl ${
                scrolled ? "text-foreground-900" : "text-white"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-900"
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap bg-accent-500 text-background-50 hover:bg-accent-600 text-center mt-2"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}